import { render, staticRenderFns } from "./speechdraft.vue?vue&type=template&id=4c0bda40&scoped=true"
import script from "./speechdraft.vue?vue&type=script&lang=js"
export * from "./speechdraft.vue?vue&type=script&lang=js"
import style0 from "./speechdraft.vue?vue&type=style&index=0&id=4c0bda40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0bda40",
  null
  
)

export default component.exports